type ResultType = User;
type ApiResponseType = ApiSchema['GetUserResponse'];
type ParamsType = object;

/**
 * Fetch user info of authenticated user
 */
export default async function apiLoadUser(): Promise<ApiResult<ResultType>> {
    try {
        return await callApiGet<ResultType, ApiResponseType, ParamsType>(
            '/account/user',

            // Request Params
            {},

            // Transform result
            (response: ApiResponseType): ResultType => {
                const passengers = response.userInfo?.travelPassengers?.map(p => transformPassenger(p, true)) ?? [];
                const lastPurchaser = transformPurchaser(response?.userInfo?.lastPurchaser);

                return {
                    details: {
                        firstName: response.userInfo?.detail?.firstName ?? '',
                        lastName: response.userInfo?.detail?.lastName ?? '',
                        email: response.userInfo?.detail?.email ?? '',
                    },
                    passengers,
                    lastPurchaser,
                };
            },
        );
    }
    catch (error) {
        throw new Error('Failed to load user', { cause: error });
    }
}
